document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.specs-accordion-header').forEach(header => {
    header.addEventListener('click', function() {
      const panel = document.querySelector(`#${header.dataset.target}`);
      const toggle = header.querySelector('.specs-toggle');

      if (header.classList.contains('specs-active')) {
        header.classList.remove('specs-active');
        panel.classList.remove('open');
        toggle.classList.remove('specs-active');
      } else {
        // Close all other panels
        document.querySelectorAll('.specs-accordion-header').forEach(otherHeader => {
          otherHeader.classList.remove('specs-active');
          const otherPanel = document.querySelector(`#${otherHeader.dataset.target}`);
          otherPanel.classList.remove('open');
          otherHeader.querySelector('.specs-toggle').classList.remove('specs-active');
        });

        // Open the clicked panel
        header.classList.add('specs-active');
        panel.classList.add('open');
        toggle.classList.add('specs-active');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', async function () {
  const section = document.querySelector('.custom-inventory');
  if (!section) return;

  // 1) Random percent between 30 and 70
  const pct = Math.floor(Math.random() * 41) + 30;

  // 2) IntersectionObserver to animate when in view
  const prog = section.querySelector('.progress-inner');
  if (prog) {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          prog.style.width = pct + '%';
          obs.unobserve(section);
        }
      });
    }, { threshold: 0.2 });

    io.observe(section);
  }

  const shipEl = section.querySelector('.ship-date-text');
  if (shipEl) {
    const d = new Date();
    d.setDate(d.getDate() + 1);

    // Skip Saturday
    if (d.getDay() === 6) {
      d.setDate(d.getDate() + 2);
    }

    // Skip Sunday
    if (d.getDay() === 0) {
      d.setDate(d.getDate() + 1);
    }

    // US English weekday abbreviations
    const dayMap = {
      1: 'Mon',
      2: 'Tue',
      3: 'Wed',
      4: 'Thu',
      5: 'Fri'
    };

    const weekday = dayMap[d.getDay()];
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    // US format: Tue 03/25
    shipEl.textContent = `${weekday} ${month}/${day}`;
  }

  // 3) Show visitor country flag at the end
  const flagEl = section.querySelector('.visitor-country-flag');

  function countryCodeToFlag(code) {
    return code
      .toUpperCase()
      .replace(/./g, char => String.fromCodePoint(127397 + char.charCodeAt()));
  }

  if (flagEl) {
    try {
      const res = await fetch('https://ipapi.co/json/');
      if (!res.ok) throw new Error('Country lookup failed');

      const data = await res.json();

      if (data.country_code) {
        flagEl.textContent = countryCodeToFlag(data.country_code);
        flagEl.title = data.country_name || data.country_code;
        flagEl.setAttribute(
          'aria-label',
          data.country_name || data.country_code
        );
      }
    } catch (error) {
      console.warn('Could not load visitor country flag:', error);
      flagEl.textContent = '';
    }
  }
});